import { render, staticRenderFns } from "./SocialButtons.vue?vue&type=template&id=2e1370c6"
import script from "./SocialButtons.vue?vue&type=script&lang=js"
export * from "./SocialButtons.vue?vue&type=script&lang=js"
import style0 from "./SocialButtons.vue?vue&type=style&index=0&id=2e1370c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports